import * as types from '@/store/mutation-types';

export default {
  [types.setKeyword](state, paylod) {
    console.log(JSON.stringify(paylod));
    if (paylod) {
      state.setKeyword = paylod;
    }
  },
  [types.keywordUpdate](state, paylod) {
    state.setKeyword = paylod.newProperties;
    console.log(JSON.stringify(paylod), JSON.stringify(paylod.newProperties));
  },
};



// WEBPACK FOOTER //
// ./src/store/keyword/keywordMutaions.js